<template>
    <div>
      <nav class="navbar navbar-light fixed-top bg-light flex-lg-nowrap p-0 shadow">
        <a class="navbar-brand col-4 col-sm-3 col-md-4 mr-0" href="#">
          <img src="../assets/img/hokodo_logo_color.svg" width="100" alt="">
        </a>
        <button class="navbar-toggler d-inline d-lg-none mr-2" type="button" @click="toggleMobileMenu()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <transition name="fade">
          <div class="d-lg-none navbar-collapse collapse show" v-if="mobileMenuShow">
            <ul class="navbar-nav ml-3">
              <li class="nav-item">
                <router-link to="/home/account" class="nav-link"><icon name="user"></icon>&nbsp; Account</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/home/dashboard" class="nav-link"><icon name="home"></icon>&nbsp; Dashboard <span class="badge badge-primary badge-sm ml-2">COMING SOON</span></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/home/developer" class="nav-link"><icon name="cpu"></icon>&nbsp; Developer</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/home/change-log" class="nav-link"><icon name="activity"></icon>&nbsp; Release notes</router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://bnpl.docs.hokodo.co/" target="_blank"><icon name="book"></icon> Documentation</a>
              </li>
            </ul>
            <ul class="navbar-nav px-3 mt-3">
              <li class="nav-item text-nowrap">
                <a class="nav-link" href="#" v-on:click="logout" :disabled="loggingOut"><icon name="power"></icon>&nbsp; Sign out</a>
              </li>
            </ul>
          </div>
        </transition>
      </nav>

      <div class="container-fluid">
        <div class="row">
          <nav class="col-lg-3 col-xl-2 d-none d-lg-block bg-light sidebar">
            <div class="sidebar-sticky">
              <ul class="nav flex-column mt-5">
                <li class="nav-item">
                  <router-link to="/home/account" class="nav-link"><icon name="user"></icon> Account</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/home/dashboard" class="nav-link"><icon name="home"></icon> Dashboard <span class="badge badge-primary badge-sm ml-2">COMING SOON</span></router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/home/developer" class="nav-link"><icon name="cpu"></icon> Developer</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/home/change-log" class="nav-link"><icon name="activity"></icon> Release notes</router-link>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="https://bnpl.docs.hokodo.co/" target="_blank"><icon name="book"></icon> Documentation</a>
                </li>
              </ul>
              <ul class="nav flex-column sign-out-btn">
                <li class="nav-item text-nowrap pt-2 mb-2">
                  <a class="nav-link" href="#" v-on:click="logout" :disabled="loggingOut"><icon name="power"></icon> Sign out</a>
                </li>
              </ul>
            </div>
          </nav>

          <main role="main" class="ml-lg-auto col-lg-9 col-xl-10 px-4 px-xl-1">
            <nav class="navbar bg-banner shadow px-4" v-for="(notification,index) in notifications" :key="index">
              <div class="navbar-banner"><b class="banner-header">{{notification.title}}</b> <span v-html="notification.message"></span></div>
            </nav>
            <div class="container-fluid px-4 pr-lg-5">
              <account v-if="!component || (component == 'account')"></account>
              <dashboard v-else-if="component && (component == 'dashboard')"></dashboard>
              <developer v-else-if="component && (component == 'developer')"></developer>
              <change-log v-else-if="component && (component == 'change-log')"></change-log>
              <div v-else>
                  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-5 pb-2 mb-3 border-bottom">
                    <h1 class="h2">Not Found</h1>
                  </div>
                  <p>The page that you are looking for could not be found</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
</template>

<script>
import Account from './home/Account'
import Dashboard from './home/Dashboard'
import Developer from './home/Developer'
import ChangeLog from './home/ChangeLog'
import home from '../api/home'

export default {
  data () {
    return {
      loggingOut: false,
      mobileMenuShow: false,
      notifications: []
    }
  },
  props: ['component'],
  mounted () {
    this.$store.dispatch('user/get')
    this.getNotifications()
  },
  components: {
    Account,
    Dashboard,
    Developer,
    ChangeLog
  },
  methods: {
    logout: function () {
      this.loggingOut = true
      this.$store.dispatch('auth/logout').then(() => {
        // Successfully logged out - redirect
        this.$router.push({name: 'Login', params: {message: 'logged-out'}})
        this.loggingOut = false
      }, (error) => {
        // Logout failed
        this.loggingOut = false
        console.log(error)
      })
    },
    toggleMobileMenu: function () {
      if (this.mobileMenuShow) {
        this.mobileMenuShow = false
      } else {
        this.mobileMenuShow = true
      }
    },
    hideMobileMenu: function () {
      this.mobileMenuShow = false
    },
    getNotifications: function () {
      home.getNotifications(
        response => {
          this.notifications = response.notifications
        },
        error => {
          console.log('Get notifications failed', error)
        })
    }
  },
  watch: {
    '$route' () {
      this.hideMobileMenu()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue